// supabaseClient.js
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://zozxyebdjbitnofnnwjb.supabase.co'
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inpvenh5ZWJkamJpdG5vZm5ud2piIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzE0MDY0NjgsImV4cCI6MjA0Njk4MjQ2OH0.WfpRB6TT7ez3cU8ShuPr1-PmMF7SlGvC_ZycFKbP9uE';

// Create and export a single Supabase client instance
export const supabase = createClient(supabaseUrl, supabaseKey);
